import { useState } from "react";
import { useParams } from "react-router";
import useRestaurant from "../utils/useRestaurant";
import Shimmer from "./Shimmer";
import RestroCategory from "./RestroCategory";

const RestroMenu = () => {
    const { resId } = useParams();
    const { resInfo, menuInfo } = useRestaurant(resId);
    const [openIndex, setOpenIndex] = useState(null);

    if (!resInfo || !menuInfo) return <Shimmer />;

    // Group menu items by category
    const categories = menuInfo.reduce((acc, item) => {
        if (!acc[item.category]) {
            acc[item.category] = [];
        }
        acc[item.category].push(item);
        return acc;
    }, {});

    const categoryNames = Object.keys(categories);

    return (
        <div className="max-w-3xl mx-auto px-6 py-10">
            {/* Restaurant header */}
            <div className="pb-6 border-b border-gray-200 mb-6">
                <h1 className="font-extrabold text-3xl text-gray-900">{resInfo.name}</h1>
                <p className="text-gray-500 mt-1">{resInfo.cuisines}</p>
                <div className="flex items-center gap-3 mt-3">
                    <span className="inline-flex items-center gap-1 bg-green-100 text-green-700 text-sm font-bold px-3 py-0.5 rounded">
                        ★ {resInfo.avgRating}
                    </span>
                    <span className="text-gray-400 text-sm">30–40 min</span>
                </div>
            </div>

            {/* Menu label */}
            <h2 className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-4">Menu</h2>

            {/* Accordion categories */}
            <div>
                {categoryNames.map((category, index) => (
                    <RestroCategory
                        key={category}
                        category={category}
                        items={categories[category]}
                        isOpen={openIndex === index}
                        onToggle={() => setOpenIndex(openIndex === index ? null : index)}
                    />
                ))}
            </div>
        </div>
    );
};

export default RestroMenu;
